import ngMaterial from 'angular-material';
import uiRouter from 'angular-ui-router';

import angularTranslate from 'angular-translate';
import * as supportRequest from './support.controller';
import gzEula from 'gazelle/src/components/user/eula/eula.module';
import gazelleAnalytics from 'gazelle/src/core/analytics/analytics.module';
import gzHpId from 'gazelle/src/components/hpid/hpid.module';

// import this modules components


import './support.scss';

// define the module in one place and export the module name
export default angular.module('register.components.support', [
  gzEula,
  gzHpId,
  uiRouter,
  ngMaterial,
  angularTranslate,
  gazelleAnalytics,
  'rhino.components.locale',
  'rhino.core',
  'angulartics',
  'ngFileUpload'
])
  .controller(supportRequest.name, supportRequest.default)
  .name;



// WEBPACK FOOTER //
// ./components/support/support.module.js